
export const SET_AVAILABLE_PROJECTS = 'SET_AVAILABLE_PROJECTS';
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';

export const SET_AVAILABLE_PLANS = 'SET_AVAILABLE_PLANS';
export const SET_SELECTED_PLAN = 'SET_SELECTED_PLAN';
export const SET_PLAN_VISIBLE_LAYERS = 'SET_PLAN_VISIBLE_LAYERS';

export const SET_SELECTED_VIEWPOINT = 'SET_SELECTED_VIEWPOINT';
export const SET_LEFT_YAW = 'SET_LEFT_YAW';
export const SET_LEFT_PITCH = 'SET_LEFT_PITCH';
export const SET_LEFT_HFOV = 'SET_LEFT_HFOV';
export const SET_SPLIT_VIEW = 'SET_SPLIT_VIEW';
export const SET_TAG_LEGENDS_VISIBLE = 'SET_TAG_LEGENDS_VISIBLE';

export const SET_DARK_MODE = 'SET_DARK_MODE';
export const SET_PROJECT_SELECT_VISIBLE = 'SET_PROJECT_SELECT_VISIBLE';

export const SET_PLANVIEW_STATE = 'SET_PLANVIEW_STATE';
export const SET_PLANVIEW_POSITION = 'SET_PLANVIEW_POSITION';


export const setAvailableProjects = projects => {
    return {
        type: SET_AVAILABLE_PROJECTS,
        payload: projects
    };
};


export const setSelectedProject = project => {
    return {
        type: SET_SELECTED_PROJECT,
        payload: project
    };
};


export const setProjectSelectVisible = visible => {
    return {
        type: SET_PROJECT_SELECT_VISIBLE,
        payload: visible
    };
};


export const setAvailablePlans = plans => {
    return {
        type: SET_AVAILABLE_PLANS,
        payload: plans
    };
};


export const setSelectedPlan = plan => {
    return {
        type: SET_SELECTED_PLAN,
        payload: plan
    };
};


export const setSelectedViewpoint = viewPointId => {
    return {
        type: SET_SELECTED_VIEWPOINT,
        payload: viewPointId
    };
};


export const setSplitView = split => {
    return {
        type: SET_SPLIT_VIEW,
        payload: split
    };
};


export const setTagsLegendVisible = visible => {
    return {
        type: SET_TAG_LEGENDS_VISIBLE,
        payload: visible
    };
};


export const setLeftYaw = yaw => {
    return {
        type: SET_LEFT_YAW,
        payload: yaw
    };
};


export const setLeftPitch = pitch => {
    return {
        type: SET_LEFT_PITCH,
        payload: pitch
    };
};


export const setLeftHfov = hfov => {
    return {
        type: SET_LEFT_HFOV,
        payload: hfov
    };
};


export const setPlanVisibleLayers = plan => {
    return {
        type: SET_PLAN_VISIBLE_LAYERS,
        payload: plan
    };
};


export const setDarkMode = darkMode => {
    return {
        type: SET_DARK_MODE,
        payload: darkMode
    };
};


export const setPlanViewPosition = position => {
    return {
        type: SET_PLANVIEW_POSITION,
        payload: position
    };
};


export const setPlanViewState = state => {
    return {
        type: SET_PLANVIEW_STATE,
        payload: state
    };
};

